const React = require('react');
const T = require('prop-types');
const { default: styled } = require('styled-components');

const { default: IconButton } = require('@mui/material/IconButton');
const { default: NotificationsIcon } = require('@mui/icons-material/Notifications');
const UnreadMessagesBadge = require('../UnreadMessagesBadge');
const { default: Classes } = require('./styles.scss');
const { default: Tooltip } = require('@mui/material/Tooltip');
const TooltipIconAnchor = require('components/TooltipIconAnchor');

const internals = {};

const NotificationsButton = (props) => {

    const {
        unreadCount,
        color,
        dispatch, // eslint-disable-line no-unused-vars
        disabled,
        ...other
    } = props;

    const { StyledIconButton } = internals;

    return (
        <Tooltip
            arrow
            title={disabled ? '' : 'Notifications'}
            placement='bottom'
            style={{ pointerEvents: disabled ? 'none' : 'auto' }}
        >
            <TooltipIconAnchor>
                <StyledIconButton
                    {...other}
                    aria-label='view notifications'
                    size='large'
                >
                    <NotificationsIcon color={color} />
                    <UnreadMessagesBadge className={Classes.badge} numUnreads={unreadCount} />
                </StyledIconButton>
            </TooltipIconAnchor>
        </Tooltip>
    );
};

NotificationsButton.propTypes = {
    color: T.string,
    unreadCount: T.number,
    dispatch: T.func, // Comes from redux
    disabled: T.bool
};

module.exports = NotificationsButton;

internals.StyledIconButton = styled(IconButton)`
    width: 52px;
    height: 52px;

    color: ${({ theme }) => theme.palette.primary.contrast} !important;

    svg {
        width: ${({ theme }) => theme.constants.iconSize}px;
        height: ${({ theme }) => theme.constants.iconSize}px;
    }

    &:focus-visible {
        background-color: rgba(255, 255, 255, 0.5);
    }
`;
